var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchResults } from "@/hooks/useSearchResults";
import { Warning } from "@/components/SearchResults/Warning";
import { TwoPane } from "@/components/cortex";
export var SearchResultsView = function (_a) {
    var loading = _a.loading, error = _a.error, searchData = _a.searchData;
    if (error) {
        return _jsx(Warning, { text: "Error occurred. Try again later", severity: "error" });
    }
    if (loading) {
        return _jsx(Warning, { text: "Loading..." });
    }
    if (!searchData || searchData.jobs.length === 0) {
        return _jsx(Warning, { text: "No jobs right now, check back soon!" });
    }
    return _jsx(TwoPane, { searchData: searchData });
};
export var SearchResults = function () { return (_jsx(SearchResultsView, __assign({}, useSearchResults()))); };
